import script from "./OpeningSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningSection.vue?vue&type=script&setup=true&lang=js"

import "./OpeningSection.vue?vue&type=style&index=0&id=42aca560&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42aca560"]])

export default __exports__